import { FormEvent, useCallback, useState } from 'react';
import { noop } from '../../lib';
import {
  focusFirstError,
  FormErrors,
  getFormElementArray,
  getFormElements,
  getFormValues,
  getNumErrors,
  validateFormElements,
  Validations
} from './form';

type Props = {
  focusOnError?: boolean;
  // eslint-disable-next-line @typescript-eslint/ban-types
  onSubmit?: Function;
  validations?: Validations;
};

export const useForm = ({ focusOnError = true, onSubmit = noop, validations = {} }: Props = {}) => {
  const [errors, setErrors] = useState<FormErrors>({});

  const handleSubmit = useCallback(
    (evt: FormEvent) => {
      evt.preventDefault();

      const form = evt.target as HTMLFormElement;
      const formElementArray = getFormElementArray(form);
      const formElements = getFormElements(formElementArray);
      const formValues = getFormValues(formElements);
      const formErrors = validateFormElements(formElements, validations);
      const numErrors = getNumErrors(formErrors);

      setErrors(formErrors);

      if (numErrors === 0) {
        onSubmit(formValues, formElements, form);
      } else if (focusOnError) {
        focusFirstError(formErrors, formElementArray);
      }
    },
    [focusOnError, onSubmit, validations]
  );

  const numErrors = getNumErrors(errors);
  const hasErrors = numErrors > 0;

  return { errors, handleSubmit, hasErrors, numErrors };
};
